import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiLinux, SiVisualstudiocode, SiPostman, SiSlack, SiJira, SiTrello,
  SiJetbrains, SiJupyter, SiMacos, SiMicrosoftteams, SiZoom, SiGooglemeet,
 SiDiscord,SiGoogle, SiDocker, SiGithubactions, SiGitlab,
   SiNginx, SiApachekafka,
  SiStreamlit, SiKaggle, SiMlflow, SiSelenium, SiPlaywright
} from "react-icons/si";

function Toolstack() {
  const iconSize = { fontSize: "3rem" };
  const toolNameStyle = {
    fontSize: "0.85rem",
    textAlign: "center",
    marginTop: "8px",
    color: "#EDE9FF"
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {/* === OPERATING SYSTEMS === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiLinux size={iconSize} />
        <div style={toolNameStyle}>Linux</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMacos size={iconSize} />
        <div style={toolNameStyle}>macOS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode size={iconSize} />
        <div style={toolNameStyle}>VS Code</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiJetbrains size={iconSize} />
        <div style={toolNameStyle}>JetBrains</div>
      </Col>

      {/* === API & TESTING === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman size={iconSize} />
        <div style={toolNameStyle}>Postman</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPlaywright size={iconSize} />
        <div style={toolNameStyle}>Playwright</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSelenium size={iconSize} />
        <div style={toolNameStyle}>Selenium</div>
      </Col>

      {/* === CONTAINERS & DEVOPS === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiDocker size={iconSize} />
        <div style={toolNameStyle}>Docker</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGithubactions size={iconSize} />
        <div style={toolNameStyle}>GitHub Actions</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGitlab size={iconSize} />
        <div style={toolNameStyle}>GitLab CI</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNginx size={iconSize} />
        <div style={toolNameStyle}>NGINX</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiApachekafka size={iconSize} />
        <div style={toolNameStyle}>Kafka</div>
      </Col>

      {/* === MONITORING === */}
     
      
    
   

      {/* === ML TOOLS === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiJupyter size={iconSize} />
        <div style={toolNameStyle}>Jupyter</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiKaggle size={iconSize} />
        <div style={toolNameStyle}>Kaggle</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMlflow size={iconSize} />
        <div style={toolNameStyle}>MLflow</div>
      </Col>
<Col xs={4} md={2} className="tech-icons">
        <SiStreamlit size={iconSize} />
        <div style={toolNameStyle}>Streamlit</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMlflow size={iconSize} />
        <div style={toolNameStyle}>MLflow</div>
      </Col>
      {/* === PROJECT MANAGEMENT === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiJira size={iconSize} />
        <div style={toolNameStyle}>Jira</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTrello size={iconSize} />
        <div style={toolNameStyle}>Trello</div>
      </Col>
    

      {/* === COMMUNICATION === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiSlack size={iconSize} />
        <div style={toolNameStyle}>Slack</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMicrosoftteams size={iconSize} />
        <div style={toolNameStyle}>MS Teams</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiZoom size={iconSize} />
        <div style={toolNameStyle}>Zoom</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGooglemeet size={iconSize} />
        <div style={toolNameStyle}>Google Meet</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDiscord size={iconSize} />
        <div style={toolNameStyle}>Discord</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGoogle size={iconSize} />
        <div style={toolNameStyle}>Google Docs</div>
      </Col>

    </Row>
  );
}

export default Toolstack;
